export default __webpack_public_path__ + "static/media/les_yeux_coulent.9720eb00.jpg";